/* HFB-072 — Keep preview params on selector links, and scroll the current card into view. */
(function () {
  function previewParams() {
    var current = new URLSearchParams(window.location.search);
    var keep = [];
    current.forEach(function (value, key) {
      if (key === "view" || key === "preview_theme_id" || key.indexOf("convert_") === 0) {
        keep.push([key, value]);
      }
    });
    return keep;
  }

  function withPreview(href) {
    var keep = previewParams();
    if (!href || !keep.length) return href;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return href;
    }
    for (var i = 0; i < keep.length; i++) {
      if (!url.searchParams.has(keep[i][0])) url.searchParams.set(keep[i][0], keep[i][1]);
    }
    return url.pathname + url.search + url.hash;
  }

  function applyPreviewLinks() {
    var links = document.querySelectorAll(".hfb-072__card, .hfb-072__all");
    for (var i = 0; i < links.length; i++) {
      var next = withPreview(links[i].getAttribute("href"));
      if (next) links[i].setAttribute("href", next);
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest && event.target.closest(".hfb-072__card, .hfb-072__all");
      if (!link) return;
      var next = withPreview(link.getAttribute("href"));
      if (next) link.setAttribute("href", next);
    },
    true
  );

  function shown(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function crumbAnchor() {
    var root = document.getElementById("product-main");
    if (!root) return null;
    var selectors = [
      ".spdp-v2-crumbs",
      ":scope > .abtest_pdp-redesign--mobile-only",
      "nav.breadcrumbs"
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = root.querySelectorAll(selectors[i]);
      for (var n = 0; n < nodes.length; n++) {
        if (shown(nodes[n])) return nodes[n];
      }
    }
    return null;
  }

  function shouldPlace() {
    return !!document.querySelector(".hfb-072.is-live");
  }

  var userScrolledRow = false;
  var positioning = false;
  var viewportWidth = window.innerWidth;

  function rowFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest(".hfb-072__row");
  }

  document.addEventListener(
    "scroll",
    function (event) {
      if (positioning || !rowFromEvent(event)) return;
      userScrolledRow = true;
    },
    true
  );

  document.addEventListener(
    "touchstart",
    function (event) {
      if (rowFromEvent(event)) userScrolledRow = true;
    },
    { capture: true, passive: true }
  );

  function place() {
    if (!shouldPlace()) return;
    var bar = document.querySelector(".hfb-072");
    var mount = document.querySelector("[data-hfb-072]");
    if (!bar) return;
    var row = bar.querySelector(".hfb-072__row");
    var savedLeft = row ? row.scrollLeft : 0;
    bar.classList.add("is-placed");

    if (window.innerWidth > 959) {
      bar.classList.remove("is-under");
      if (mount && bar.parentElement !== mount) mount.appendChild(bar);
      return;
    }

    var anchor = crumbAnchor();
    if (anchor) {
      if (bar.previousElementSibling !== anchor) anchor.insertAdjacentElement("afterend", bar);
    } else if (mount && bar.parentElement !== mount) {
      mount.appendChild(bar);
    }
    bar.classList.add("is-under");
    if (userScrolledRow && row) row.scrollLeft = savedLeft;
  }

  function scrollCurrent() {
    if (userScrolledRow || window.innerWidth > 959) return;
    var card = document.querySelector(".hfb-072__card--current");
    if (!card || card.offsetParent === null) return;
    var row = card.closest(".hfb-072__row");
    if (!row) return;
    var left = card.offsetLeft - 15;
    if (left < 0) left = 0;
    positioning = true;
    row.scrollLeft = left;
    window.requestAnimationFrame(function () {
      positioning = false;
    });
  }

  function sync() {
    place();
    applyPreviewLinks();
    scrollCurrent();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }

  window.addEventListener("load", sync);

  var resizeTimer;
  window.addEventListener("resize", function () {
    var nextWidth = window.innerWidth;
    if (nextWidth === viewportWidth) return;
    viewportWidth = nextWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector("[data-hfb-072]")) sync();
  });
})();
